// Names interpolated into a markdown hint (showdown) must not open emphasis or code: a resource named
// CT_MySQL_Report otherwise renders as "CTMySQLReport" with "MySQL" in italics. Mirrors the backend
// ValidationMessage::escapeMarkdown().
export const escapeMarkdown = (text: string): string => text.replace(/([\\`*_])/g, '\\$1');
